import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  ArtContainer,
  ArtGrid,
  ArtCard,
  ArtImage,
  ArtOverlay,
  ArtTitle,
  ArtDescription,
  ViewButton,
  CategoryFilter,
  FilterButton
} from "../styles/ArtStyle";
import PageLayout from "../components/PageLayout";
import axios from "axios";
import Footer from "../components/Footer";

function Art() {
  const [categories, setCategories] = useState("All");
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [artProjects, setArtProjects] = useState([]);
  const [filteredProjects, setFilteredProjects] = useState(artProjects);
  const [loading, setLoading] = useState(true);


  // Fetch data on mount
  useEffect(() => {
    axios.get('/art')
      .then(response => {
        const data = response.data;

        setArtProjects(data);
        setFilteredProjects(data);

        // Build unique categories from all projects
        const allCategories = [].concat(
	   ...data.map(p => Array.isArray(p.category) ? p.category : (p.category ? [p.category] : []))
	)
          // .flatMap(project => project.category || []) // handles array
          // .filter(Boolean); // remove null/undefined/empty

        const uniqueCategories = Array.from(new Set(allCategories));

        setCategories(["All", ...uniqueCategories]);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error fetching art projects:', error);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    if (selectedCategory === "All") {
      setFilteredProjects(artProjects);
    } else {
      setFilteredProjects(artProjects.filter(project => project.category === selectedCategory));
    }
  }, [artProjects, selectedCategory]);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <PageLayout>
      <ArtContainer>
        <CategoryFilter>
          {categories.map((category) => (
            <FilterButton
              key={category}
              active={selectedCategory === category}
              onClick={() => setSelectedCategory(category)}
            >
              {category}
            </FilterButton>
          ))}
        </CategoryFilter>
        <ArtGrid>
          {filteredProjects.map((project, index) => (
            <Link to={`/art/${project._id}`} key={project._id} style={{ textDecoration: 'none' }}>
              <ArtCard index={index}>
                <ArtImage src={project.image} alt={project.title} />
                <ArtOverlay className="art-overlay">
                  <ArtTitle>{project.title}</ArtTitle>
                  <ArtDescription>{project.description}</ArtDescription>
                  <ViewButton as="span">View Project</ViewButton>
                </ArtOverlay>
              </ArtCard>
            </Link>
          ))}
        </ArtGrid>
        <Footer />
      </ArtContainer>
    </PageLayout>
  );
}

export default Art;
